import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-contract-details',
  templateUrl: './custom-contract-details.component.html',
  styleUrls: ['./custom-contract-details.component.scss']
})
export class CustomContractDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
